{
  "page": {
    "title": "Campaigns"
  },
  "tab": {
    "campaigns": "Campaigns",
    "promotions": "Promotions"
  },
  "toolbar": {
    "create": "Create campaign",
    "new_campaign": "+ New Campaign",
    "search_placeholder": "Search campaigns…",
    "all_statuses": "All statuses",
    "has_active": "Has active",
    "has_finished": "All finished",
    "has_draft": "Has draft",
    "all_periods": "All periods",
    "export": "Export"
  },
  "footer": {
    "showing": "Showing {{shown}} of {{total}} campaigns"
  },
  "column": {
    "account": "Account",
    "name": "Name",
    "period": "Period",
    "created_by": "Created By",
    "status": "Status",
    "actions": "Actions"
  },
  "rollup": {
    "active": "Active",
    "draft": "Draft",
    "finish": "Finished",
    "archived": "Archived"
  },
  "form": {
    "name_label": "Campaign name",
    "name_placeholder": "e.g. Songkran GWP 2026",
    "create_title": "Create campaign",
    "rename_title": "Rename campaign",
    "submit_create": "Create",
    "submit_rename": "Save",
    "cancel": "Cancel",
    "err_name_required": "Campaign name is required"
  },
  "action": {
    "rename": "Rename",
    "archive": "Archive",
    "delete": "Delete"
  },
  "delete": {
    "confirm_title": "Delete campaign?",
    "confirm_body": "This cannot be undone.",
    "blocked": "Cannot delete: this campaign has active promotions."
  },
  "empty": {
    "title": "No campaigns yet",
    "body": "Create your first campaign to group promotions."
  }
}
